<template>
  <p class="text-xs text-grey-dark my-3 leading-normal">
    By saving this card you authorise StrataVault to store your card details
    and automatically charge this card for your subscription fees on a
    recurring basis, until you cancel or change your payment method.
  </p>
</template>

<script>
// Stored-credential (CIT/MIT) consent disclosure. Card networks require a
// consent statement wherever a card is saved for recurring charges.
export default {
  name: "CardStorageConsent",
};
</script>
